import { HttpService } from '@/services/HttpService';

class Mfa {
  subdomain = '/mfa';

  postSendCode() {
    return HttpService.post(`${this.subdomain}/sendCode`, {});
  }

  postVerifyCode(code) {
    return HttpService.post(`${this.subdomain}/verify`, { code });
  }

  postResendCode() {
    return HttpService.post(`${this.subdomain}/resend`, {});
  }

  postChangeStatus(data) {
    return HttpService.post(`${this.subdomain}/change-status`, data);
  }

  getMfaStatus() {
    return HttpService.get(`${this.subdomain}/status`);
  }
}

export default new Mfa();
